import React, { ReactNode } from 'react';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { Avatar, Link } from '@gravity-ui/uikit';
import Gear from '@gravity-ui/icons/Gear';
import { routes } from 'client/lib/routes';
import { useLocation } from 'react-router-dom';
import { Logo } from '../icons/Logo';
import * as keyset from 'i18n/Header';
import * as generalKeyset from 'i18n/GeneralSettings';
import { LangSwitcher } from '../LangSwitcher/LangSwitcher';

import styles from './Header.module.scss';

const t = i18n(keyset);
const tGeneral = i18n(generalKeyset);

const PassportLinkWrapper = ({ children }: React.PropsWithChildren<ReactNode>) => {
    const { passport } = __appConfig;
    const { pathname, search } = useLocation();
    const href = encodeURIComponent(window.location.origin + pathname + search);
    const passportLink = `${passport}?retpath=${href}`;
    return (
        <Link className={styles.passportLinkWrapper} href={passportLink}>
            {children}
        </Link>
    );
};

export const Header = () => {
    const { user } = __appConfig;
    return (
        <header className={clx(styles.header, styles.header_settingPage)}>
            <a className={clx(styles.logo__container, styles.logo__container_settingPage)} href={routes.app.root}>
                <Logo />
            </a>
            <div className={styles.rightHeaderBlock}>
                {user && (
                    <>
                        <Link className={styles.header__link} href={routes.app.root}>
                            {t('projects')}
                        </Link>
                        <Link
                            className={clx(styles.header__link, styles.header__link_hideInMobile)}
                            href={routes.app.settings()}
                        >
                            <Gear />
                            {tGeneral('header-settings')}
                        </Link>
                        <LangSwitcher />
                        <PassportLinkWrapper>
                            <Avatar
                                className={styles.header__avatar}
                                imgUrl={`https://avatars.mds.yandex.net/get-yapic/${user.blackbox.avatar?.default || '0/0-0'}/islands-middle`}
                                size="xs"
                            />
                            {user.blackbox.displayName}
                        </PassportLinkWrapper>
                    </>
                )}
            </div>
        </header>
    );
};

export const HeaderIndex = () => {
    const { user } = __appConfig;
    return (
        <header className={clx(styles.header, styles.header_indexPage)}>
            <a className={clx(styles.logo__container, styles.logo__container_indexPage)} href={routes.app.root}>
                <Logo />
            </a>
            <div className={styles.rightHeaderBlock}>
                {user && (
                    <>
                        <Link
                            className={clx(styles.header__link, styles.header__link_hideInMobile)}
                            href={routes.app.settings()}
                        >
                            <Gear />
                            {tGeneral('header-settings')}
                        </Link>
                        <LangSwitcher />
                        <PassportLinkWrapper>
                            <Avatar
                                className={styles.header__avatar}
                                imgUrl={`https://avatars.mds.yandex.net/get-yapic/${user.blackbox.avatar?.default || '0/0-0'}/islands-middle`}
                            />
                            {user.blackbox.displayName}
                        </PassportLinkWrapper>
                    </>
                )}
            </div>
        </header>
    );
};
